export default __webpack_public_path__ + "static/media/ohi-pc-view.28e0a74d.webp";